import Model from '@/models/ExtendModel'

export default class PchPaymentCondition extends Model {
    resource() {
        return 'pch_payment_condition'
    }
}